export const SET_LOGIN_MODAL_VISIBILITY = 'SET_LOGIN_MODAL_VISIBILITY'
export const SET_UPDATE_LOGIN_STATUS = 'SET_UPDATE_LOGIN_STATUS'
export const REDIRECT_AFTER_LOGIN = 'REDIRECT_AFTER_LOGIN'
export const SET_DEALER_MODE = 'SET_DEALER_MODE'
